import Vue from 'vue'
import Vuex from 'vuex'
import { getSiteConfig } from '@/api'

// 动态设置页签图标：Canvas 裁切为正方形
function setFavicon(url) {
  if (!url) return
  const img = new Image()
  img.crossOrigin = 'anonymous'
  img.onload = () => {
    const size = 64
    const canvas = document.createElement('canvas')
    canvas.width = size
    canvas.height = size
    const ctx = canvas.getContext('2d')
    const min = Math.min(img.width, img.height)
    const sx = (img.width - min) / 2
    const sy = (img.height - min) / 2
    ctx.drawImage(img, sx, sy, min, min, 0, 0, size, size)
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = canvas.toDataURL('image/png')
  }
  img.src = url
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: localStorage.getItem('portal_lang') || 'ru',
    siteConfig: {},
    loading: false
  },
  mutations: {
    SET_LANG(state, lang) { state.lang = lang; localStorage.setItem('portal_lang', lang) },
    SET_CONFIG(state, config) { state.siteConfig = config },
    SET_LOADING(state, val) { state.loading = val }
  },
  actions: {
    setLang({ commit }, lang) { commit('SET_LANG', lang) },
    async loadSiteConfig({ commit, state }) {
      try {
        const res = await getSiteConfig(state.lang)
        if (res.data?.code === 200) {
          commit('SET_CONFIG', res.data.data)
          setFavicon(res.data.data.siteLogo)
        }
      } catch (e) { /* use defaults */ }
    }
  }
})
